<template>
  <footer class="mobile-footer">
    <max-width-container>
      <nav-link-list
        class="mobile-footer__links"
        view-type="both"
        context="special"
        data-track-as="navi.special"
        :links="[...specialLinks]"
      />
      <nav-link-list
        class="mobile-footer__links"
        view-type="label"
        data-track-as="navi.general"
        :links="[...mainLinks, ...generalLinks]"
      />
      <nav-link-list
        v-show="languages.length > 0"
        class="mobile-footer__links"
        view-type="label"
        upper-case
        data-track-as="navi.general"
        :links="languages"
      />
    </max-width-container>
  </footer>
</template>

<script>
import MaxWidthContainer from '../common/MaxWidthContainer'
import NavLinkList from '../common/NavLinkList'
import { useNavigationTypeFilter } from '../composables/useNavigationTypeFilter'

export default {
  name: 'MobileFooter',
  components: { NavLinkList, MaxWidthContainer },
  props: {
    level1Links: {
      type: Array,
      required: true,
    },
    secondaryLinks: {
      type: Array,
      required: true,
    },
    languages: {
      type: Array,
      required: true,
    },
  },
  setup(props) {
    const { generalLinks, specialLinks, mainLinks } =
      useNavigationTypeFilter(props)
    return {
      generalLinks,
      specialLinks,
      mainLinks,
    }
  },
}
</script>

<style>
.mobile-footer {
  background-color: var(--c-primary-neutral-2);
  margin: 0 calc(var(--body-offset-horizontal) * -1);
  padding: var(--spacing-4) var(--body-offset-horizontal);
}

.mobile-footer__links {
  flex: 1 100%;
  margin-bottom: var(--spacing-6);
}

.mobile-footer__links:last-child {
  margin-bottom: 0;
}
</style>
